/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import "aframe";
import "./App.css";
import React from "react";
import Controllers from "./controllers/Controllers";
import Room from "./rooms/Room";
import Players from "./players/Players";
import Ferrari from "./players/Ferrari";
import KeyboardHandler from "./widgets/keyboard/KeyBoardHandler";
import Toolbar from "./components/toolbar/Toolbar";
import AudioContainer from "./components/AudioContainer";
import Clara3D from "./players/Clara3D";

function App() {
    const intersectClasses = ".collidable>a-box, .collidable>a-cylinder, .collidable";

    // Use a custom font in order to support non ASCII characters..
    window.AFRAME.customFont = `${window.location.origin}/assets/fonts/Roboto-Regular-msdf.json`;

    return (
        <a-scene keyboard-shortcuts="enterVR: false" inspector="url:false">
            <a-assets>
                <img
                    id="sky"
                    src="/assets/room/labdef.jpg"
                    alt="sky"
                    crossOrigin="anonymous"
                />
                <img
                    id="CheckboxMark"
                    src="/assets/icons/CheckmarkIcon.png"
                    alt="checkbox_mark"
                />
                <img id="Settings" src="/assets/icons/settings.png" alt="settings_icon" />
                <img
                    id="SortingUp"
                    src="/assets/icons/ArrowUp.svg"
                    alt="sorting_up_icon"
                />
                <img
                    id="SortingDown"
                    src="/assets/icons/ArrowDown.svg"
                    alt="sorting_down_icon"
                />
                <img
                    id="micEnabled"
                    src="/assets/icons/micEnabled.png"
                    alt="mic_enabled"
                />
                <img
                    id="micDisabled"
                    src="/assets/icons/micDisabled.png"
                    alt="mic_disabled"
                />
                <img
                    id="Oculus"
                    src="/assets/icons/oculus.png"
                    alt="oculus"
                />
                <img
                    id="Windows"
                    src="/assets/icons/windows.png"
                    alt="windows"
                />
                <img id="Logout" src="/assets/icons/logout.png" alt="logout_icon" />
                <img id="Share" src="/assets/icons/share.png" alt="share_icon" />
                <img id="Back" src="/assets/icons/back.png" alt="back_icon" />
                <img id="ClaraChat" src="/assets/icons/clara.png" alt="clara_chat_icon" />
                <img id="clara" src="/assets/icons/claraNeutral.svg" alt="clara_neutral_icon" />
                <img id="claraHappy" src="/assets/icons/claraHappy.svg" alt="clara_happy_icon" />
                <img id="claraSad" src="/assets/icons/claraSad.svg" alt="clara_sad_icon" />
                <img id="Home" src="/assets/icons/home.png" alt="home_icon" />
                <img id="Warning" src="/assets/icons/warn.png" alt="warning_icon" />
                <img
                    id="CloseBlack"
                    src="/assets/icons/CloseBlack.svg"
                    alt="close_black_icon"
                />
                <img
                    id="CloseWhite"
                    src="/assets/icons/CloseWhite.png"
                    alt="close_white_icon"
                />
                <img
                    id="BlockedStatus"
                    src="/assets/icons/status/Blocked.png"
                    alt="blocked_status_icon"
                ></img>
                <img
                    id="CanceledStatus"
                    src="/assets/icons/status/Canceled.png"
                    alt="canceled_status_icon"
                ></img>
                <img
                    id="ErrorStatus"
                    src="/assets/icons/status/Error.png"
                    alt="error_status_icon"
                ></img>
                <img
                    id="HeldStatus"
                    src="/assets/icons/status/Held.png"
                    alt="held_status_icon"
                ></img>
                <img
                    id="ReadyStatus"
                    src="/assets/icons/status/Ready.png"
                    alt="ready_status_icon"
                ></img>
                <img
                    id="RunningStatus"
                    src="/assets/icons/status/Running.png"
                    alt="running_status_icon"
                ></img>
                <img
                    id="SuccessfulStatus"
                    src="/assets/icons/status/Successful.png"
                    alt="successful_status_icon"
                ></img>
                <img
                    id="SuppressedStatus"
                    src="/assets/icons/status/Suppressed.png"
                    alt="suppressed_status_icon"
                ></img>
                <img
                    id="UndecidedStatus"
                    src="/assets/icons/status/Undecided.png"
                    alt="undecided_status_icon"
                ></img>
                <img
                    id="WaitingStatus"
                    src="/assets/icons/status/Waiting.png"
                    alt="waiting_status_icon"
                ></img>
                <AudioContainer />

                <a-asset-item id="player-obj" src="/assets/player.obj"></a-asset-item>
                <a-asset-item id="player-mtl" src="/assets/player.mtl"></a-asset-item>
                <a-asset-item id="clara-mtl" src="/assets/clara.mtl"></a-asset-item>
                <a-asset-item id="clara-obj" src="/assets/clara.obj"></a-asset-item>
                <a-asset-item id="claraSad-mtl" src="/assets/claraSad.mtl"></a-asset-item>
                <a-asset-item id="claraSad-obj" src="/assets/claraSad.obj"></a-asset-item>
                <a-asset-item id="claraHappy-mtl" src="/assets/claraHappy.mtl"></a-asset-item>
                <a-asset-item id="claraHappy-obj" src="/assets/claraHappy.obj"></a-asset-item>
                <a-asset-item id="ferrari-mtl" src="/assets/ferrari.mtl"></a-asset-item>
                <a-asset-item id="ferrari-obj" src="/assets/ferrari.obj"></a-asset-item>
            </a-assets>
            <a-sky src="#sky" />
            <Players intersectClasses={intersectClasses} />
            <Clara3D />
            <Ferrari />

            <Room />
            <KeyboardHandler />

            <Toolbar />
            <Controllers intersectClasses={intersectClasses} />
        </a-scene>
    );
}

export default App;
